import { Directive, ElementRef, HostBinding } from "@angular/core";
import { ConstantsService } from "@app/services/constantsService";
import './hide-production.directive.scss';

@Directive({
    selector: '[hideInProduction]'
})
export class HideInProductionDirective {

    @HostBinding('class.hide-production') hideClass = true;
    constructor(private readonly el: ElementRef,
        private readonly constantsService: ConstantsService) { }

    ngOnInit(): void {
        this.setDisplay();
    }

    private setDisplay(): void {
        if (this.constantsService.getIsProduction()) {
            this.el.nativeElement.remove();
            return;
        }
    }
}
